import { render, staticRenderFns } from "./CategoryOverviewModal.vue?vue&type=template&id=32796cc4&"
import script from "./CategoryOverviewModal.vue?vue&type=script&lang=js&"
export * from "./CategoryOverviewModal.vue?vue&type=script&lang=js&"
import style0 from "./CategoryOverviewModal.vue?vue&type=style&index=0&id=32796cc4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports